import createAsyncActions from '../../_utils/createAsyncActions';
import { TCatchesState } from './catchesModel';

/**/
export enum ECatchesActions {
  ADD_CARD = 'catches/ADD_CARD',
  CHANGE_FILTER = 'catches/CHANGE_FILTER',
  CHANGE_PERIOD = 'catches/CHANGE_PERIOD',
  FETCH_CATCH_DATA = 'catches/FETCH_CATCH_DATA',
  FETCH_OPTIONS = 'catches/FETCH_OPTIONS',
  FETCH_VIZ_DATA = 'catches/FETCH_VIZ_DATA',
  OPEN_PANEL = 'catches/OPEN_PANEL',
  REMOVE_CARDS = 'catches/REMOVE_CARDS',
  RESET_FILTERS = 'catches/RESET_FILTERS',
  SET_CATCH_MODE = 'catches/SET_CATCH_MODE'
}

/**/
export const fetchCatchDataSet = createAsyncActions<TCatchesState>(
  ECatchesActions.FETCH_CATCH_DATA
);

export const fetchOptionsSet = createAsyncActions<TCatchesState>(
  ECatchesActions.FETCH_OPTIONS
);

export const fetchVizSet = createAsyncActions<TCatchesState>(
  ECatchesActions.FETCH_VIZ_DATA
);

/**/
export const START_YEAR = 2023;
export const WEIGHT_RANGE = [1, 999];
const YEAR_LIST_LENGTH = 5;
const currentYear = new Date().getFullYear();

export const YEAR_LIST = Array(YEAR_LIST_LENGTH)
  .fill(null)
  .map((_, idx) => currentYear - idx);

/**/
export const INITIAL_SETTINGS = {
  equipment: [],
  // isBW: false,
  species: [], // [17, 7, 56, 2, 3], // NS Herring, Mackerel, Redfish Mentella, haddock, saithe
  types: [],
  vessels: [],
  weight: WEIGHT_RANGE
};

/**/
export const PARAMS_MAP = {
  end: 'end',
  equipment: 'gearIds',
  species: 'specieIds',
  start: 'start',
  types: 'vesselTypeIds',
  vessels: 'vesselIds',
  years: 'years'
};
